/**
 * Founder allowlist — the LoRA Training surface is founder-only (Leslie + Grace).
 *
 * The admin id_token carries `is_admin` but no `founder` role, and "founder" here
 * is a strict two-person set (NOT all admins), so we gate by email. Grace
 * (grace@proximax.ai) isn't registered yet — gating by email means she has access
 * the moment she signs in, before any flag/role is provisioned for her.
 *
 * Edit FOUNDER_EMAILS to add/remove founders. Lowercased compare.
 */
import type { IdTokenClaims } from './token-store.js';

export const FOUNDER_EMAILS = [
  'leslie@proximax.ai',
  'leslieliu@gmail.com',
  'grace@proximax.ai',
] as const;

export function isFounder(user: IdTokenClaims | null | undefined): boolean {
  const email = user?.email?.toLowerCase();
  return !!email && (FOUNDER_EMAILS as readonly string[]).includes(email);
}
